import React, { Component } from 'react';
import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { connect } from 'react-redux';
import saga from '../../sagas/circle/new';
import Module from '../../modules/circle/new';
import ServicesCategoriesBox from '../../components/circle/services_categories_box';
import ModalAlert from '../../components/modal/modal_alert';

const sagaMiddleware = createSagaMiddleware();
createStore(Module.reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(saga);

export default class FormPage1 extends Component {
  render() {
    return <Root guideline={this.props.guideline} isApp={this.props.isApp} companyId={this.props.companyId} type={this.props.type}/>;
  }
}

class TmpRoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkDisabled:
        this.props.selectedGenres && this.props.selectedGenres.length > 2
          ? true
          : false,
      initialOpenServices: {
        51: false,
        52: false,
        53: false,
        54: false,
        55: false,
        56: false,
        57: false,
        58: false,
      },
      selectedMode: null,
      isLoading: false,
    };
    this.onChangeSelectedGenre = this.onChangeSelectedGenre.bind(this);
    this.onClickPageBtn = this.onClickPageBtn.bind(this);
    this.selectHobbyMode = this.selectHobbyMode.bind(this);
    this.selectOshikatsuMode = this.selectOshikatsuMode.bind(this);
    this.onChangeOshikatsuCircle = this.onChangeOshikatsuCircle.bind(this);
    this.onClickClearAllGenres = this.onClickClearAllGenres.bind(this);
  }

  onClickClearAllGenres() {
    let circle = { ...this.props.circle };
    circle.is_oshikatsu_circle = false;
    this.props.changeFields(circle);
    this.props.changeSelectedGenre([]);
    this.setState({ checkDisabled: false, selectedMode: null });
  }

  /**
   * 表示ページが変更された時の処理
   * @param {*} e
   */
  onClickPageBtn(e) {
    e.preventDefault();
    let circle = this.props.circle;
    const circleId = circle.id
    let serviceIds = this.props.selectedGenres.join(',');
    let category = serviceIds;
    this.setState({ isLoading: true });
    if (circle.is_oshikatsu_circle) {
      this.props.createOshikatsuGenre(circleId, serviceIds);
      this.props.updateCircle(circle);
      setTimeout(() => {
        this.setState({ isLoading: false });
        this.props.changePage('oshikatsu_circles');
      }, 2000);
    } else {
      this.props.createCategory(circle.id, category);
      this.props.updateCircle(circle);
      this.setState({ isLoading: false });
      this.props.changePage(e.target.value);
    }
  }

  onChangeSelectedGenre(e) {
    const selectedGenre = e.target.value;
    let tmpSelectedGenres = [...this.props.selectedGenres];
    const position = tmpSelectedGenres.indexOf(selectedGenre);
    if (position === -1) {
      tmpSelectedGenres.push(selectedGenre);
    } else {
      tmpSelectedGenres.splice(position, 1);
    }

    let circle = { ...this.props.circle };
    const oshikatsuServices = this.props.servicesCategories.filter(
      (service) => service.circle_type === 10
    );
    this.props.changeFields(circle);
    this.props.changeSelectedGenre(tmpSelectedGenres);
    const maxSelectable = circle.is_oshikatsu_circle ? 1 : 3;
    if (tmpSelectedGenres.length > maxSelectable && position === -1) {
      tmpSelectedGenres.pop();
    }
    this.setState({ checkDisabled: tmpSelectedGenres.length > maxSelectable });
  }

  /**
   * コンポーネントマウント時の処理
   */
  componentDidMount() {
    if (this.props.isDisableCreateCircle) {
      this.modalAlertDisableCreateCircle.openModal();
    }

    const services_categoreies = this.props.servicesCategories;
    const selectGenres = this.props.selectedGenres;
    let openServices = { ...this.state.initialOpenServices };

    services_categoreies.map((services) => {
      const tmp_service_categories = services.categories.map((genre) =>
        String(genre.id)
      );

      for (const item of [...selectGenres, ...tmp_service_categories]) {
        if (
          selectGenres.includes(item) &&
          tmp_service_categories.includes(item)
        ) {
          openServices[services.id] = true;
        }
      }
    });
    this.setState({ initialOpenServices: openServices });
  }

  UNSAFE_componentWillMount() {
    if (
      this.props.selectedGenres.length === 0 &&
      this.props.circle.categories !== undefined
    ) {
      const tmpGenresArray =
        this.props.circle.categories.map((item) => item.id.toString()) || [];
      this.props.changeSelectedGenre(tmpGenresArray);
      const checkDisabled = tmpGenresArray.length > 2 ? true : false;
      this.setState({
        checkDisabled: checkDisabled,
      });
    }
  }

  selectHobbyMode() {
    this.setState((prevState) => ({
      selectedMode: prevState.selectedMode === 'hobby' ? null : 'hobby'
    }));
  }

  selectOshikatsuMode() {
    this.setState((prevState) => ({
      selectedMode: prevState.selectedMode === 'oshikatsu' ? null : 'oshikatsu'
    }));
  }

  onChangeOshikatsuCircle(e) {
    let circle = { ...this.props.circle };
    circle.is_oshikatsu_circle = e.target.checked;
    this.props.changeFields(circle);
  }

  render() {
    const { selectedMode } = this.state;
    const isHobbyOpen = selectedMode === 'hobby';
    const isOshikatsuOpen = selectedMode === 'oshikatsu';  
    const hobbyMaxHeight = isHobbyOpen ? '1000px' : '0px';
    const oshikatsuMaxHeight = isOshikatsuOpen ? '1000px' : '0px';
    const isCompanyOrDepartment = this.props.companyId || this.props.type === 'department';
    
    const hobbyServices = this.props.servicesCategories.filter(
      (service) => service.circle_type === 0
    );
    const oshikatsuServices = this.props.servicesCategories.filter(
      (service) => service.circle_type === 10
    );
    if (this.state.isLoading) {
      return (
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      );
    }
    return (
      <div>
        <main
          className="bg-gray h-100 pt-3 min-vh-100"
          style={{
            paddingBottom: this.props.isApp == false ? '168px' : '112px',
          }}
        >
          <div className="container col-md-8 col-lg-6">
            <ol className="list-unstyled list-makecircle d-flex text-center justify-content-center mt-3">
              <li
                className="list-makecircleitem text-fz-small"
                onClick={this.onClickPageBtn}
                value="2"
              >
                基本情報
              </li>
              <li
                className="list-makecircleitem text-fz-small"
                onClick={this.onClickPageBtn}
                value="3"
              >
                設定
              </li>
            </ol>
            {isCompanyOrDepartment ? (
              <div>
                <p className="text-fz-14px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
                  サークルのジャンル
                </p>
                <p className="message-required d-inline-block mb-2 ml-1">必須</p>
                <p className="text-fz-small text-black-50">
                  ※ サークルのジャンルは3つまで選択できます。
                </p>
              {/* <div className="shadow-sm bg-white pt-4 pb-4 mb-4">
                <div className="position-relative container col-md-8 col-lg-6">
                  <div className="form-control__wrap">
                    <input className="form-control mb-0 pl-5 form-control__circle d-inline-block" type="text" placeholder="キーワードを入力" onChange={this.props.onChangeGenreKeyword} />
                    <button type="reset" className="btn-reset border-0 p-0"><img src="/assets2019/img/icon_delete.png" alt="" className="w-100" /></button>
                  </div>
                  <button type="submit" className="btn-sm d-inline-block btn-searchsubmit">検索</button>
                </div>
              </div> */}
                <div className="bg-white" style={{maxHeight: '800px', overflowY: 'auto', width: '100%'}}>
                  <div className="container col-md-8 col-lg-6 pl-0 pr-0">
                    <ServicesCategoriesBox
                      servicesCategories={this.props.servicesCategories}
                      onChangeSelectedGenre={this.onChangeSelectedGenre}
                      selectedGenres={this.props.selectedGenres}
                      checkDisabled={this.state.checkDisabled}
                      initialOpenGenre={this.state.initialOpenServices}
                    />
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <p className="text-fz-18px text-fw-bold text-black-50 mb-2 mt-3 d-inline-block">
                サークルのジャンルを選択する前に…
                </p>
                <p className="text-fz-16px text-black-50">
                  「趣味活」か「推し活」どちらの用途で作りますか？
                </p>
                <div className="mt-3 mb-4">
                  <p className="text-fz-small text-black-50">
                    「趣味活」「推し活」を変更する際は、一度選択を解除してから、新しく選択してください。
                  </p>
                  <button
                    type="button"
                    className={`col-6 a-button a-button__top mr-2 w-100 ${
                      this.props.isApp === false ? 'mb-2' : ''
                    }`}
                    style={{
                      backgroundColor: '#fff',
                      color: '#333',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '0.5rem 1rem',
                      minWidth: '120px',
                      cursor: 'pointer',
                    }}
                    onClick={this.onClickClearAllGenres}
                  >
                    選択中のジャンルを解除
                  </button>
                </div>
                <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
                  <button
                    className="mode-select-button"
                    onClick={this.selectHobbyMode}
                    style={{ color: '#ff4d5b' }}
                  >
                    趣味活
                  </button>
                  {/* 趣味活用ジャンル表示 */}
                  {isHobbyOpen && (
                    <div
                      style={{
                        overflow: 'hidden',
                        transition: 'max-height 0.5s ease-in-out',
                        maxHeight: hobbyMaxHeight,
                      }}
                    >
                      <p className="d-flex justify-content-start text-fz-small text-black-50 mb-2">
                        ※ サークルのジャンルは3つまで選択できます。（趣味活）
                      </p>
                      <div className="bg-white">
                        <div className="container pl-0 pr-0" style={{ maxHeight: '800px', overflowY: 'auto' }}>
                          <ServicesCategoriesBox
                            servicesCategories={hobbyServices}
                            onChangeSelectedGenre={this.onChangeSelectedGenre}
                            selectedGenres={this.props.selectedGenres}
                            checkDisabled={this.state.checkDisabled}
                            initialOpenGenre={this.state.initialOpenServices}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                {/* 推し活トグル */}
                <div className="container px-0 d-flex">
                  <div>
                    <p className="text-fz-14px text-fw-bold text-black-50 mb-0 mt-2 d-inline-block">
                      このサークルを「推し活」用にする
                    </p>
                    <p className="text-fz-small text-black-50">
                      「推し活」用のサークルは、一般的なサークルと、選択するカテゴリが異なります。（特定のアイドル、アニメ、スポーツ選手など）
                    </p>
                  </div>
                  <div className="container mt-2 col-auto d-flex align-items-center justify-content-center">
                    <div className="toggle_switch d-flex">
                      <input
                        type="checkbox"
                        id="is_oshikatsu_circle"
                        className="toggle_input"
                        checked={!!this.props.circle.is_oshikatsu_circle}
                        onChange={this.onChangeOshikatsuCircle}
                      />
                      <label
                        htmlFor="is_oshikatsu_circle"
                        className="mb-0 toggle_label"
                      ></label>
                    </div>
                  </div>
                </div>
                <div style={{ marginBottom: '1rem', textAlign: 'center' }}>
                  <button
                    className="mode-select-button"
                    onClick={this.selectOshikatsuMode}
                    style={{ color: '#ff4d5b' }}
                  >
                    推し活
                  </button>
                </div>
                {/* 推し活用ジャンル */}
                {isOshikatsuOpen && (
                  <div
                    style={{
                      overflow: 'hidden',
                      transition: 'max-height 0.5s ease-in-out',
                      maxHeight: oshikatsuMaxHeight
                    }}
                  >
                    <div>
                      <p className="text-fz-small text-black-50 mb-2">
                        ※ ジャンルを<span className="text-fw-bold" style={{ color: '#ff4d5b' }}>1つだけ</span>選択してください。。（推し活用）
                      </p>
                      <div className="bg-white">
                        <div className="container pl-0 pr-0" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                          <ServicesCategoriesBox
                            servicesCategories={oshikatsuServices}
                            onChangeSelectedGenre={this.onChangeSelectedGenre}
                            selectedGenres={this.props.selectedGenres}
                            checkDisabled={this.state.checkDisabled}
                            initialOpenGenre={this.state.initialOpenServices}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </main>

        <div className="fixed-bottom" style={{ paddingBottom: '8px' }}>
          <div className="container col-md-8 col-lg-6">
            <div
              className="d-flex justify-content-around"
              style={{ marginBottom: this.props.isApp == true ? '24px' : '' }}
            >
              <button
                type="button"
                className={`a-button a-button__top a-button--orange mr-2 w-50 ${
                  this.props.isApp == false ? 'mb-2' : ''
                }`}
                onClick={this.onClickPageBtn}
                value="2"
                disabled={
                  typeof this.props.selectedGenres === 'undefined' ||
                  this.props.selectedGenres.length === 0
                    ? true
                    : false
                }
              >
                次へ
              </button>
            </div>
          </div>
        </div>
        <ModalAlert
          ref={(c) => {
            this.modalAlertDisableCreateCircle = c;
          }}
          id="modalAlertDisableCreateCircle"
          title="サークル作成上限を超えています。"
          content="作成上限の10個を超えています。下書き状態での作成となります。"
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...state,
    guideline: ownProps.guideline,
    isApp: ownProps.isApp,
    companyId: ownProps.companyId,
    type: ownProps.type
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeGenreKeyword: (genreKeyword) => {
      dispatch(Module.actions.changeGenreKeyword({ genreKeyword }));
    },
    changePage: (pageNum) => {
      dispatch(Module.actions.changePage({ pageNum }));
    },
    changeSelectedGenre: (selectedGenres) => {
      dispatch(Module.actions.changeSelectedGenre({ selectedGenres }));
    },
    updateCircle: (circle, isSubmit = false) => {
      dispatch(Module.actions.updateCircle({ circle, isSubmit }));
    },
    createCategory: (circleId, category) => {
      dispatch(Module.actions.createCategory({ circleId, category }));
    },
    createOshikatsuGenre: (circleId, serviceIds) => {
      dispatch(Module.actions.createOshikatsuGenre({ circleId, service: serviceIds }));
    },
    changeFields: (circle) => {
      dispatch(Module.actions.changeFields({ circle }));
    },
  };
};

const Root = connect(mapStateToProps, mapDispatchToProps)(TmpRoot);
